import { FormElementProps } from 'components/common/form/index';
import { FormsContextType } from 'components/common/form/hooks/useFormContext';
import { getElementFieldValue } from 'components/common/form/formTools';
import { mergeObjectDeep } from 'tools/tools';
import { DependencyRule, FormComponentDependency } from 'components/common/form/dependency/index';
import { processEffect } from 'components/common/form/dependency/processEffect';
import checkRule from 'components/common/form/dependency/checkRule';

const isPlainObject = (value: unknown): value is Record<string, any> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

export default function applyComponentCondition(
    elementProps: FormElementProps,
    formsContext: FormsContextType,
    contextProps?: any,
    formTriggerSave?: number,
) {
    let resultProps = {};
    if (typeof contextProps != 'undefined') {
        resultProps = { ...contextProps };
    }
    if (typeof elementProps.component.props != 'undefined') {
        resultProps = { ...resultProps, ...elementProps.component.props };
    }

    if (!elementProps.component.deps?.length || !elementProps.form.formDidMount) {
        return resultProps;
    }

    elementProps.component.deps
        .filter((dep) => dep.scope == 'control')
        .forEach((dep: FormComponentDependency) => {
            let rulesValid = true;
            dep.rules.forEach((rule: DependencyRule) => {
                if (rule.field == '$form.save' && typeof formTriggerSave != 'undefined') {
                    return (rulesValid = elementProps.form.triggerSave?.current != formTriggerSave);
                }
                let fieldValue = getElementFieldValue(elementProps.form, rule.field, formsContext);
                rulesValid = rulesValid && checkRule(rule, fieldValue, elementProps.form, formsContext);
            });
            if (rulesValid) {
                const effect = processEffect(elementProps, dep, formsContext);
                // mergeObjectDeep writes nested keys in place; detach the touched objects so the
                // component definition keeps its original values and the effect lifts when the rule stops matching
                Object.keys(effect).forEach((key) => {
                    const current = (resultProps as any)[key];
                    if (isPlainObject(effect[key]) && isPlainObject(current)) {
                        (resultProps as any)[key] = { ...current };
                    }
                });
                resultProps = mergeObjectDeep(resultProps, effect);
            }
        });
    return resultProps;
}
